// VFX: Kinetic Word Punch
// Slug: text_kinetic_word-punch_1000ms
// Category: kinetic-typography
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;
type Word = { text: string; color?: string; size?: number };
type Props = { words?: Word[]; holdFrames?: number; bgColor?: string };

const DEFAULT_WORDS: Word[] = [
  { text: "STOP", color: "#ef4444", size: 120 },
  { text: "using", color: "rgba(255,255,255,0.5)", size: 60 },
  { text: "BLACK", color: "#ffffff", size: 100 },
  { text: "backgrounds", color: "rgba(255,255,255,0.4)", size: 50 },
];

export default function TextKineticWordPunch1000ms({
  words = DEFAULT_WORDS,
  holdFrames = 18,
  bgColor = "#050508",
}: Props) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const totalPerWord = holdFrames + 12;
  const wordIndex = Math.min(Math.floor(frame / totalPerWord), words.length - 1);
  const wordFrame = frame % totalPerWord;
  const currentWord = words[wordIndex];
  const p = spring({ frame: wordFrame, fps, config: { damping: 80, stiffness: 300, mass: 0.6 } });
  return (
    <AbsoluteFill style={{ background: bgColor, justifyContent: "center", alignItems: "center" }}>
      <div
        style={{
          fontSize: currentWord?.size || 80,
          fontWeight: 900,
          fontFamily: "system-ui, sans-serif",
          color: currentWord?.color || "#ffffff",
          textAlign: "center",
          padding: "0 40px",
          lineHeight: 1,
          opacity: p,
          transform: `scale(${interpolate(p, [0, 1], [1.4, 1], clamp)})`,
          letterSpacing: "-2px",
        }}
      >
        {currentWord?.text}
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
